import { Card } from "@/components/ui/card";

export default function AvisoLegalPage() {
  return (
    <div className="container mx-auto px-4 py-16">
      <div className="max-w-4xl mx-auto">
        <h1 className="font-headline text-4xl font-bold text-primary mb-2 text-center">Aviso Legal y Condiciones de Uso</h1>
        <p className="text-center text-muted-foreground mb-8">Última actualización: 24 de agosto de 2026</p>
        <Card className="prose dark:prose-invert max-w-none p-6">
          <h2>1. DATOS IDENTIFICATIVOS</h2>
          <p>
            En cumplimiento del artículo 10 de la Ley 34/2002, de Servicios de la Sociedad de la
            Información y del Comercio Electrónico (LSSI-CE), se informa de que el titular y responsable de
            este sitio web es <strong>David Fouces Morales</strong> (en adelante, «Jartiland» o «el
            titular»), con correo electrónico de contacto
            {" "}<a href="mailto:jartiland5@gmail.com">jartiland5&#64;gmail.com</a>.
          </p>

          <h2>2. OBJETO Y ACEPTACIÓN</h2>
          <p>
            Jartiland es una plataforma web sin ánimo de lucro para la comunidad cofrade en torno a un
            servidor de Minecraft temático. El acceso y el uso del sitio atribuyen la condición de USUARIO
            e implican la aceptación de estas Condiciones de Uso. Si no estás de acuerdo con ellas, no uses
            la plataforma.
          </p>

          <h2>3. REQUISITOS DE USO</h2>
          <p>
            Para registrarte y usar el área privada «Jartinet» debes tener <strong>al menos 14 años</strong>.
            El USUARIO es responsable de aportar información veraz en el registro y de custodiar su
            contraseña, comprometiéndose a hacer un uso diligente y confidencial de la misma y a no cederla
            a terceros.
          </p>

          <h2>4. USO CORRECTO DEL PORTAL</h2>
          <p>
            El USUARIO se compromete a hacer un uso adecuado de los contenidos y servicios y, en particular,
            a no emplearlos para: (i) incurrir en actividades ilícitas o contrarias a la buena fe y al orden
            público; (ii) difundir contenidos racistas, xenófobos, pornográficos ilegales, de apología del
            terrorismo o que atenten contra los derechos humanos; (iii) introducir virus o sistemas que
            puedan dañar los sistemas del titular o de terceros; (iv) suplantar a otros usuarios o entidades.
          </p>

          <h2>5. MONEDA VIRTUAL Y JUEGOS INTERNOS</h2>
          <p>
            La plataforma incluye funcionalidades lúdicas con una moneda virtual interna (el «banco» y los
            juegos como JartiBet). Esta moneda es <strong>ficticia, carece de valor monetario real</strong>,
            no es canjeable por dinero ni por bienes fuera de la comunidad, y su único uso es recreativo
            dentro de Jartiland. Estas funcionalidades no constituyen juego de azar con dinero real.
          </p>

          <h2>6. PROPIEDAD INTELECTUAL E INDUSTRIAL</h2>
          <p>
            El titular es propietario o licenciatario de todos los derechos de propiedad intelectual e
            industrial de la web y de sus elementos (imágenes, audio, vídeo, software, textos, marcas,
            logotipos, diseño y estructura). Quedan prohibidas la reproducción, distribución y comunicación
            pública, total o parcial, de los contenidos con fines comerciales sin autorización del titular
            (arts. 8 y 32.1 de la Ley de Propiedad Intelectual).
          </p>
          <p>
            Los contenidos que los usuarios publiquen (fotos, textos) siguen siendo suyos, pero al
            publicarlos conceden a Jartiland una licencia gratuita y no exclusiva para mostrarlos dentro de
            la plataforma. Las marcas, nombres y contenidos de terceros que puedan aparecer pertenecen a sus
            respectivos titulares.
          </p>
          <p>
            <strong>Aviso sobre Minecraft:</strong> Jartiland es un proyecto de aficionados, no oficial y no
            afiliado ni patrocinado por Mojang Studios ni por Microsoft. «Minecraft» es una marca de Mojang
            Synergies AB.
          </p>

          <h2>7. EXCLUSIÓN DE GARANTÍAS Y RESPONSABILIDAD</h2>
          <p>
            El titular no se responsabiliza, dentro de los límites de la ley, de los daños derivados de:
            errores u omisiones en los contenidos, falta de disponibilidad del portal o presencia de virus,
            pese a haber adoptado medidas razonables para evitarlo.
          </p>

          <h2>8. MODIFICACIONES</h2>
          <p>
            El titular se reserva el derecho de modificar sin previo aviso los contenidos y servicios del
            portal, así como estas condiciones. La versión vigente será siempre la publicada en esta página.
          </p>

          <h2>9. LEGISLACIÓN APLICABLE Y JURISDICCIÓN</h2>
          <p>
            La relación entre Jartiland y el USUARIO se rige por la normativa española vigente. Para
            cualquier controversia, las partes se someten a los Juzgados y Tribunales que correspondan
            conforme a la ley.
          </p>
        </Card>
      </div>
    </div>
  );
}
